import React, { useContext } from "react";
import styled from "styled-components";
import { Button } from "baseui/button";
import { useNavigate } from "react-router-dom";
import AppContext from "../AppContext";

const Outer = styled.div`
	color: ${(props) => props.theme.black};
`;

const Menu = styled.div`
	box-sizing: border-box;
	background-color: ${(props) => props.theme.grey};
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	width: 10rem;

	display: grid;
	grid-template-areas:
		"logo"
		"nav"
		"bottom";
	grid-template-rows: min-content auto min-content;

	> img {
		width: 100%;
		padding: 1rem;
		box-sizing: border-box;
		grid-area: logo;
	}
	> nav {
		grid-area: nav;
		> ul {
			list-style-type: none;
			margin: 0;
			padding: 0;
			> li {
				box-sizing: border-box;
				padding: 1rem;
				font-weight: 500;
				cursor: pointer;

				&.active {
					background-color: rgba(255, 255, 255, 0.4);
				}
			}
		}
	}
	> div {
		padding: 1rem;
		box-sizing: border-box;
		grid-area: bottom;
	}
`;

const Content = styled.div`
	margin-left: 11.5rem;
	margin-right: 1.5rem;
	margin-top: 1rem;
	margin-bottom: 1rem;

	hr {
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
		margin-left: -0.5rem;
		margin-right: -0.5rem;
		border: none;
		border-top: 0.2rem solid ${(props) => props.theme.grey};
	}
`;

const Main = (props: any) => {
	const navigate = useNavigate();
	const appContext = useContext(AppContext);

	return (
		<>
			<Outer>
				<Menu>
					<img
						src="/assets/ppcs.svg"
						alt="PPCS"
						onClick={() => {
							navigate({
								pathname: "/",
							});
						}}
					/>
					<nav>
						{appContext.state.auth.signingIn ? (
							<>Loading</>
						) : (
							<ul>
								{appContext.state.currentUser?.items &&
									appContext.state.currentUser.items.map((item: any) => {
										return (
											<li
												onClick={() => {
													navigate({
														pathname: item.identifier,
													});
												}}
											>
												{item.label}
											</li>
										);
									})}
							</ul>
						)}
					</nav>
					<div>
						<Button
							onClick={() => {
								appContext.mutate.signOut();
							}}
							isLoading={appContext.state.auth.signingOut === true}
						>
							Sign Out
						</Button>
					</div>
				</Menu>
				<Content>{props.children}</Content>
			</Outer>
		</>
	);
};
export default Main;
